'use strict';
const { readPreference, preferenceCookie } = require('../../shared/public/locale-preference.cjs');

// Only an explicit, allowlisted public-page choice reaches the existing UI
// language store. This bridge never reads or writes authentication storage.
async function consumePublicLocalePreference(document, selectLanguage, secure = false) {
  let locale;
  try { locale = readPreference(document?.cookie); } catch { return null; }
  if (!locale) return null;
  await selectLanguage(locale);
  try { document.cookie = preferenceCookie(locale, secure, true); } catch { /* Language remains usable with blocked cookies. */ }
  return locale;
}
module.exports = { consumePublicLocalePreference };
